import { AxiosPromise } from 'axios'

import { makeRequest } from 'utils/requests'

// this is a first use of a typeguard (and tbh it doesnt feel that good)
export const isRequestSuccessGuard = (res: unknown): boolean =>
  typeof res === 'object' &&
  res !== null &&
  'success' in res &&
  Boolean((res as { success?: boolean })?.success)

export const getSearchParamFromData = (data: Record<string, any>) => {
  let cleanObj: Record<string, any> = {}
  for (const prop in data) {
    if (data[prop] !== undefined && data[prop] !== null) {
      cleanObj[prop] = data[prop]
    }
    if (Array.isArray(data[prop])) {
      data[prop].forEach((val: string, index: number) => {
        cleanObj[`${prop}[${index}]`] = val
      })
      delete cleanObj[prop]
    }
  }
  return new URLSearchParams(cleanObj)
    .toString()
    .replaceAll(new RegExp('\\+', 'g'), '%20')
}

export const sendShareEmails = (
  data: Record<string, any>,
): AxiosPromise<any> => {
  const body = getSearchParamFromData(data)
  return makeRequest({
    method: 'post',
    url: '/json/orders/resend_emails',
    data: body,
  })
}
